export const getFileExt = (fileName: string) => {
  if (fileName) {
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex !== -1 ? fileName.substring(dotIndex).toLowerCase() : '';
  }

  return '';
};